import React from 'react';
import Page from './Page';

import './RealEstatePage.css';

export class RealEstatePage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			highlighted: 1
		};
	}

	render() {
		return (
			<Page className="RealEstatePage fullwidth" title="B2Me for real estate">
				<div className="headerImg">
					<div className="content">
						<h1>
							The platform <br />
							connecting real-estate <br />
							agents to communities
						</h1>
						<div>
							<p>
								B2Me for Real Estate lets you build a digital directory of services within the
								locality of each property you want to list. From cafes and restaurants to plumbers
								and electricians, B2Me enables you to showcase local businesses and service
								providers to clients and new residents to the area. B2Me for Real Estate
								demonstrates a commitment to supporting local and encourages community connection.
							</p>
						</div>
					</div>
				</div>

				<section>
					<div className="About">
						<div className="imgDiv" />
						<div className="content">
							<h1>About B2Me for Real Estate</h1>
							<p>
								You already know that a huge part of understanding the property market is knowing
								what drives people to buy. One of the main drivers for buyers is knowing that
								they'll be able to connect to a thriving local community. That's why we formed B2Me
								for Real Estate; a business directory application that allows real estate companies
								and agents to connect with local businesses in the area in which they work. Build
								your credibility by feeling confident in answering more of your client's questions
								about where they'll be moving to, the services available in the area and generate
								leads through referrals and connections to local businesses. Join B2Me today, and
								experience the difference that a localised, community-based business directory can
								make.
							</p>
						</div>
					</div>
				</section>

				<section className="localSection">
					<div
						className={`${this.state.highlighted === 0 && 'highlight'}`}
						onMouseOver={() => this.setState({highlighted: 0})}>
						<span>Local Services</span>
						<p>Bring people and businesses together within your local community</p>
					</div>

					<div
						className={`${this.state.highlighted === 1 && 'highlight'}`}
						onMouseOver={() => this.setState({highlighted: 1})}>
						<span>Local Connections</span>
						<p>Quick and easy contact with your preferred service providers and enhanced lead</p>
					</div>

					<div
						className={`${this.state.highlighted === 2 && 'highlight'}`}
						onMouseOver={() => this.setState({highlighted: 2})}>
						<span>Local Benefit</span>
						<p>Build valuable relationships and see your community flourish</p>
					</div>
				</section>

				{/* <section>
				<h1>See how agents are working with us</h1>
				<div className="agents highlight">
					<p>RE/MAX Extreme</p>
					<p>LJ Hooker Joondalup</p>
					<p>Tangent Property Group</p>
					<p>Peard Real Estate</p>
				</div>
			</section> */}

				<section>
					<h1>Moving to the future</h1>
					<p>
						Become a part of a direct and interactive digital directory that connects buyers, real
						estate agents, and local businesses.
					</p>
					<p>
						Integrate your online presence with businesses in your area and your social media
						channels to build a pipeline of interest around your real-estate business.
					</p>

					<div className="techFeatures">
						<span>Technological Features include:</span>
						<ul>
							<li>A simple onboarding process that enables a profile to be built in minutes</li>
							<li>Your B2Me Profile connects to all your social media platforms with ease</li>
							<li>
								A noticeboard to make it easier to connect to local businesses and share relevant
								community information
							</li>
							<li>
								Profiles from people living in the area and a list of their personal preferred
								service providers
							</li>
						</ul>
					</div>
				</section>

				<section className="economySection highlight">
					<div className="imgDiv" />
					<div className="content">
						<h1>An economy of trust</h1>
						<p>
							Recommendations from trusted sources are integral to the success of any business,
							including real-estate companies. Our directory focuses on making recommendations
							readily available, within a community that shares similar values and interests. By
							promoting local businesses through your directory, you'll be able to demonstrate to
							potential buyers that you are community minded and that you are trusted by a variety
							of service providers within your community. It also assures your buyer that they will
							find reliable local businesses and services in their new community.
						</p>
					</div>
				</section>

				{/* <section>
				<h1>Our gallery</h1>
			</section> */}

				<div className="testomonials">
					<h1>Testimonials</h1>
					<div className="testomonial highlight">
						<div className="header">
							<div>
								<img className="headshot" src="/img/damian-headshot.png" alt="Damian Martin" />
								<span>Damian Martin</span>
							</div>
							<img className="quote" src="/img/quote.png" alt="quote" />
						</div>
						<blockquote>
							" I've learnt, through my time in real-estate and through my time as a professional
							basketball player, that having the right people behind you makes all the difference.
							Being able to rely on B2Me, as a way of demonstrating to clients that my reputation is
							well earned, has made maintaining my property listings and my relationships with
							current and former clients all the easier. I strongly recommend that any real estate
							agent that values community starts using B2Me. "
						</blockquote>
					</div>
					<br />

					<div className="testomonial highlight">
						<div className="header">
							<div>
								<img className="headshot" src="/img/sheldon-headshot.png" alt="Sheldon Ingham" />
								<span>Sheldon Ingham - LJ Hooker Joondalup</span>
							</div>
							<img className="quote" src="/img/quote.png" alt="quote" />
						</div>
						<blockquote>
							" LJ Hooker Joondalup has a growing community of happy and valued clients who return
							to us or refer friends and family members. B2Me is a fantastic tool to further network
							online and build my community through personal connection and ongoing trust. I have
							found the staff at B2Me to be great to work with and the platform looks schmick and is
							easy to use. "
						</blockquote>
					</div>
				</div>

				<section>
					<a
						className="callToAction"
						target="_blank"
						rel="noopener noreferrer"
						href="https://share.hsforms.com/1IpKFZ73dRjyHzG9ZGQkoPw2gqzs">
						<p className="secondary">Find out how to get started with B2Me for Real Estate</p>
						<p className="primary">Get in touch</p>
					</a>
				</section>
			</Page>
		);
	}
}

export default RealEstatePage;



// WEBPACK FOOTER //
// ./src/pages/RealEstatePage.js